export const hasDevRoles = (userRoles) => {
  const devRoles = ['tester', 'superadmin']
  return devRoles.some((role) => userRoles.includes(role))
}
